import { FormItem } from '@vette/ui-components';
import { Col, Row, Skeleton } from 'antd';
import styled, { css } from 'styled-components';

export const JobOfferDetailWrapper = styled.div`
  gap: 12px;
`;

export const Wrapper = styled(Col)<{
  $fillSpace?: boolean;
  $fullHeight?: boolean;
}>`
  ${({ $fullHeight }) =>
    $fullHeight &&
    css`
      height: 100vh;
      width: 100vw;
    `}

  ${({ $fillSpace }) =>
    !$fillSpace &&
    css`
      background: url('/images/boarding.svg') no-repeat center center fixed;
      background-size: cover;
    `}
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: ${({ $fillSpace }) => ($fillSpace ? 'flex-start' : 'center')};

  & > * {
    ${({ $fillSpace }) =>
      $fillSpace
        ? css`
            height: 100vh;
          `
        : css`
            padding: 48px;
          `}
    overflow-y: auto;
    width: 100vw;
    display: flex;
    justify-content: center;
    ${({ $fullHeight }) =>
      $fullHeight &&
      css`
        max-height: 100vh;
      `}
  }

  & .ant-skeleton-input {
    border-radius: 18px;
  }
`;

export const CardRow = styled(Row)<{ $fillSpace?: boolean }>`
  background: ${({ theme }) => theme.colors.white};
  flex: 1;
  border-radius: ${({ $fillSpace }) => ($fillSpace ? 0 : '18px')};
  max-width: 924px;
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: ${({ $fillSpace }) => ($fillSpace ? '36px 0 48px' : '36px 48px')};
  height: fit-content;
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: stretch;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 36px;
`;

export const FormItemKnockoutQuestion = styled(FormItem)`
  .ant-col:first-child {
    margin-top: 10px;
  }
`;

export const ColFlex = styled(Col)`
  display: flex;
`;

export const SkeletonButton = styled(Skeleton.Button)`
  width: 100%;

  & > .ant-skeleton-button {
    width: 100%;
    height: 82px;
  }
`;

export const SkeletonCard = styled(Skeleton).attrs({
  title: true,
  paragraph: false,
  active: true,
})`
  flex: 1;
  display: flex;
  max-width: 924px;
  width: 100%;
  padding: 36px 0 48px;
  height: 100%;
  .ant-skeleton-title {
    border-radius: 18px;
    height: 100%;
    display: flex;
    flex: 1;
    margin-top: 0;
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100%;
  padding: 48px;
  justify-content: center;
`;
